import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Space,
  Modal,
  Form,
  Input,
  InputNumber,
  message,
  Popconfirm,
} from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import Layouts from "../../components/Layouts";
import {
  getImpuestos,
  createImpuesto,
  updateImpuesto,
  deleteImpuesto,
} from "../../services/impuestos";
import { useSelector } from "react-redux";
import validarpermiso from "../../lib/utils";

const Impuestos = () => {
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [form] = Form.useForm();
  const [searchText, setSearchText] = useState("");
  const permisos = useSelector((state) => state.permisos);

  // Cargar impuestos
  const loadImpuestos = async () => {
    try {
      const impuestos = await getImpuestos();
      setData(impuestos);
    } catch (error) {
      console.error("Error loading impuestos:", error);
      message.error("Error al cargar los impuestos");
    }
  };

  useEffect(() => {
    loadImpuestos();
  }, []);

  // Filtrar datos por nombre
  const filteredData = data.filter((item) =>
    item.nombre.toLowerCase().includes(searchText.toLowerCase())
  );

  // Manejar creación/edición
  const handleSubmit = async (values) => {
    try {
      if (editingRecord) {
        await updateImpuesto(editingRecord.id, values);
        message.success("Impuesto actualizado correctamente");
      } else {
        await createImpuesto(values);
        message.success("Impuesto creado correctamente");
      }
      setIsModalOpen(false);
      form.resetFields();
      setEditingRecord(null);
      loadImpuestos();
    } catch (error) {
      console.error("Error saving impuesto:", error);
      message.error("Error al guardar el impuesto");
    }
  };

  // Manejar eliminación
  const handleDelete = async (id) => {
    try {
      await deleteImpuesto(id);
      message.success("Impuesto eliminado correctamente");
      loadImpuestos();
    } catch (error) {
      console.error("Error deleting impuesto:", error);
      message.error("Error al eliminar el impuesto");
    }
  };

  // Abrir modal para edición
  const handleEdit = (record) => {
    setEditingRecord(record);
    form.setFieldsValue(record);
    setIsModalOpen(true);
  };

  // Abrir modal para creación
  const handleAdd = () => {
    setEditingRecord(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      sorter: (a, b) => a.nombre.localeCompare(b.nombre),
    },
    {
      title: "Porcentaje",
      dataIndex: "porcentaje",
      key: "porcentaje",
      render: (porcentaje) => `${porcentaje}%`,
      sorter: (a, b) => a.porcentaje - b.porcentaje,
    },
    {
      title: "Acciones",
      key: "acciones",
      render: (_, record) => (
        <Space size="middle">
         
            <Button type="link" onClick={() => handleEdit(record)}>
              Editar
            </Button>
        
         
            <Popconfirm
              title="¿Estás seguro de eliminar este impuesto?"
              onConfirm={() => handleDelete(record.id)}
              okText="Sí"
              cancelText="No"
            >
              <Button type="link" danger>
                Eliminar
              </Button>
            </Popconfirm>
        
        </Space>
      ),
    },
  ];

  return (
    <Layouts>
      <div style={{ marginBottom: 16 }}>
        <Space>
        
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAdd}
            >
              Agregar Impuesto
            </Button>
      
          <Input
            placeholder="Buscar por nombre"
            prefix={<SearchOutlined />}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 200 }}
          />
        </Space>
      </div>

      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="id"
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} impuestos`,
        }}
      />

      <Modal
        title={editingRecord ? "Editar Impuesto" : "Nuevo Impuesto"}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          form.resetFields();
          setEditingRecord(null);
        }}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="nombre"
            label="Nombre"
            rules={[{ required: true, message: "Por favor ingrese el nombre" }]}
          >
            <Input placeholder="Nombre del impuesto" />
          </Form.Item>

          <Form.Item
            name="porcentaje"
            label="Porcentaje"
            rules={[
              { required: true, message: "Por favor ingrese el porcentaje" },
              { type: "number", min: 0, max: 100, message: "El porcentaje debe estar entre 0 y 100" }
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              max={100}
              step={0.01}
              formatter={(value) => `${value}%`}
              parser={(value) => value.replace("%", "")}
            />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                {editingRecord ? "Actualizar" : "Crear"}
              </Button>
              <Button
                onClick={() => {
                  setIsModalOpen(false);
                  form.resetFields();
                  setEditingRecord(null);
                }}
              >
                Cancelar
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </Layouts>
  );
};

export default Impuestos;
